import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    textAlign: 'center',
    backgroundColor: '#f5f5f5',
  },
  subtitle: {
    fontSize: '2rem',
    marginBottom: '2rem',
    color: '#333',
  },
  errorIcon: {
    fontSize: '6rem',
    color: '#ff0000',
  },
});

const NotFound: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Container>
        <Typography
          variant="h4"
          pb={4}
          color="#7e7e7e"
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            gap: 2,
          }}>
          <ErrorOutlineIcon
            className={classes.errorIcon}
            sx={{ fontSize: 40 }}
          />
          Page Not Found
        </Typography>
        <Typography variant="body1" color="#a1a1a1">
          The page you're looking for doesn't exist or has been moved.
        </Typography>
        <Box mt={6}>
          <Button
            variant="contained"
            color="primary"
            href="/registration"
            sx={{
              textTransform: 'capitalize',
              fontWeight: 700,
              borderRadius: 2,
            }}>
            Go Back Home
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default NotFound;
